import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Component_WorkHub } from '@nu-art/work-hub-frontend/ui';
import './Page_Workspace.scss';
import { ToasterPortal_Vertical } from '@nu-art/toasting';
const Page_Workspace_BG = () => {
    return _jsxs("div", { className: 'page-workspace__bg', children: [_jsx("div", { className: 'blob blob-1' }), _jsx("div", { className: 'blob blob-2' }), _jsx("div", { className: 'blob blob-3' }), _jsx("div", { className: 'blob blob-4' }), _jsx("div", { className: 'blob blob-5' })] });
};
export const Page_Workspace = () => {
    return _jsxs(_Fragment, { children: [_jsx(Page_Workspace_BG, {}), _jsx(Component_WorkHub, { noTabsMessage: 'Knowledge Manager Workspace' }), _jsx(ToasterPortal_Vertical, { verticalPadding: 8, verticalGap: 8 })] });
};
